/** Only embed the Tourmkr origin; never accept arbitrary CMS iframe markup. */
export function getTourmkrUrl(value?: string | null): string | null {
  if (!value) return null;

  try {
    const url = new URL(value.trim().replaceAll('&amp;', '&'));
    if (
      url.protocol !== 'https:' ||
      !['tourmkr.com', 'www.tourmkr.com'].includes(url.hostname) ||
      url.username || url.password || url.port
    ) return null;

    return url.href;
  } catch {
    return null;
  }
}
